import { ROUTER_PATH } from "@config/router";
import { navigateToLoginViaSPA } from "./loginNavigationBus";

function isLoginPath(pathname: string): boolean {
  return (
    pathname === ROUTER_PATH.LOGIN ||
    pathname.startsWith(`${ROUTER_PATH.LOGIN}/`)
  );
}

/** 构建独立登录页 URL，保留 `is_native_app` 与 dev `harness*` 透传参数 */
function buildLoginPageUrl(): string {
  if (typeof window === "undefined") {
    return ROUTER_PATH.LOGIN;
  }
  const url = new URL(ROUTER_PATH.LOGIN, window.location.origin);
  const current = new URLSearchParams(window.location.search);
  for (const [key, value] of current.entries()) {
    if (key === "is_native_app" || key.startsWith("harness")) {
      url.searchParams.set(key, value);
    }
  }
  return `${url.pathname}${url.search}`;
}

function shouldSkipLoginPageRedirect(pathname: string): boolean {
  const withoutLocale = pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?\//, "/");
  return (
    isLoginPath(pathname) ||
    isLoginPath(withoutLocale) ||
    pathname.includes(ROUTER_PATH.LOGIN)
  );
}

/** 跳转独立登录页 — 优先 SPA 导航（无白屏），fallback 整页跳转 */
export function redirectToLoginPage(pathname?: string): void {
  if (typeof window === "undefined") {
    return;
  }
  const currentPath =
    pathname ?? window.location.pathname + window.location.search;
  if (shouldSkipLoginPageRedirect(currentPath)) {
    return;
  }
  const loginUrl = buildLoginPageUrl();
  const url = new URL(loginUrl, window.location.origin);
  if (!isLoginPath(currentPath) && !currentPath.startsWith("//")) {
    url.searchParams.set("returnUrl", currentPath);
  }
  const target = `${url.pathname}${url.search}`;
  if (!navigateToLoginViaSPA(target)) {
    window.location.replace(target);
  }
}
